<template>
  <div class="guidepage">
    <img class="img" :src="guidePageImg" />
  </div>
</template>

<script>
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};
export default {
  data() {
    return {
      guidePageImg: require('@/assets/img/common/guidepage.png'),
      isWechat: isWechat(),
    };
  },
};
</script>

<style lang="less" scoped>
.guidepage {
    background: #363636;
}
.img {
    position: absolute;
    width: 264px;
    height: 398px;
    top: 6px;
    right: 14px;
}
</style>